import actionBarComponent from "@/components/child/actionBar/actionBar.vue";
import checkboxComponent from "@/components/child/form/checkbox.vue";
import comboComponent from "@/components/child/form/combo.vue";
import dataTooltipComponent from "@/components/child/form/datatooltip.vue";
import { Component } from "@/decorators";
import TiposProduto from "@/models/enum/tiposProduto";
import GrupoProdutoModel from "@/models/produto/grupoProdutoModel";
import configuracaoRotuloService from "@/services/configuracaoRotuloService";
import grupoProdutoService from "@/services/produto/grupoProdutoService";

import EditComponentBase from "../editComponentBase";

@Component({
    components: {
        checkboxComponent,
        comboComponent,
        actionBarComponent,
        dataTooltipComponent,
    },
})
export default class GrupoProdutoEditComponent extends EditComponentBase<GrupoProdutoModel> {
    rotulosManipulacaoOptions: Array<Object> = [];

    tiposProdutoOptions: Array<Object> = [
        { text: "Acabado", value: TiposProduto.Acabado },
        { text: "Semi-Acabado", value: TiposProduto.SemiAcabado },
        { text: "C\u00e1psula", value: TiposProduto.Capsula },
        { text: "Embalagem", value: TiposProduto.Embalagem },
        { text: "Floral", value: TiposProduto.Floral },
        { text: "Homeopatia", value: TiposProduto.Homeopatia },
        { text: "Mat\u00e9ria-Prima", value: TiposProduto.MateriaPrima },
    ];

    private async beforeMount() {
        await this.setPropsCached(grupoProdutoService, "grupos", new GrupoProdutoModel(), false, true);
    }

    public async onLoadModel(model: GrupoProdutoModel) {
        if (model.franquiaId) {
            await this.loadRotulosManipulacao();
        }
    }

    private async loadRotulosManipulacao() {
        try {
            this.rotulosManipulacaoOptions = await configuracaoRotuloService.comboCachedManipulacao(
                this.usuarioLogado.franquiaId,
            );
        } catch {}
    }
}
